module.exports = __webpack_public_path__ + "img/xrwk.8a6acece.png";